<template>
    <div class="pl-16px text-16px line-height-28px">
        <p class="mt-48px font-bold">平台介绍</p>
        <p>
            智源研究院Brain是由智源研究院多模态大模型团队打造的首页原生多模态世界模型，多模态输入到多模态输出，现已支持文生视频、图生视频、视频续写等多个能力，让用户体验者高效完成艺术视频创作。
        </p>
        <p>
            平台链接：
            <a href="​http://Brain.baai.ac.cn/home" target="_blank"></a>
        </p>
        <p class="mt-48px font-bold">文生视频</p>
        <p>
            输入一段文字，Brain大模型根据文本表达生成3s或5s视频，将文字转变为视频画面，可以支持生成视频的时长3s、5s，参数配置纵横比同时支持3:2、2:3、16:9、9:16、1:1这五种画幅比例，更多元满足大家的视频创作需求。
        </p>
        <p>
            众所周知，“Prompt”作为大模型最主要的交互语言，将直接决定了模型返回的视频内容，因此，如何使用有效Prompt来完成AI视频创作是每个创作者都希望了解和学习的
        </p>
        <p class="mt-48px font-bold">图生视频</p>
        <p class="mt-48px font-bold">视频延长</p>
    </div>
</template>
